import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr/translation.json";
import ar from "./locales/ar/translation.json";
import en from "./locales/en/translation.json";

const savedLanguage = localStorage.getItem("language") || "fr";

const updateDirection = (language) => {
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = language;
};

updateDirection(savedLanguage);

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: fr,
    },
    ar: {
      translation: ar,
    },
    en: {
      translation: en,
    },
  },

  lng: savedLanguage,
  fallbackLng: "fr",

  interpolation: {
    escapeValue: false,
  },
});
i18n.on("languageChanged", (language) => {
  updateDirection(language);
});

export default i18n;
